import React from 'react';
import { Navbar } from 'react-bootstrap';
import { IndexLink, Link } from 'react-router';
import './ContactInvoice.less';

class ContactInvoice extends React.Component {
   render() {
      const { contactId } = this.props.params;
      return (
         <div className="ContactInvoice" >
            <h4 >Contact Invoices</h4 >
            <Navbar >
               <ul className="nav navbar-nav" >
                  <li >
                     <IndexLink to={`/contact/detail/${contactId}/invoice`} activeStyle={{ color: 'red' }} >Sale
                     </IndexLink >
                  </li >
                  <li >
                     <Link to={`/contact/detail/${contactId}/invoice/saleReturns`}
                           activeStyle={{ color: 'red' }} >Sale Returns</Link >
                  </li >
                  <li >
                     <Link to={`/contact/detail/${contactId}/invoice/purchases`}
                           activeStyle={{ color: 'red' }} >Purchases</Link >
                  </li >
                  <li >
                     <Link to={`/contact/detail/${contactId}/invoice/expenses`}
                           activeStyle={{ color: 'red' }} >Expenses</Link >
                  </li >
                  <li >
                     <Link to={`/contact/detail/${contactId}/invoice/fixedAssets`}
                           activeStyle={{ color: 'red' }} >Fixed Assets</Link >
                  </li >
               </ul >
            </Navbar >
            {this.props.children}
         </div >
      );
   }
}

ContactInvoice.propTypes = {
   params: React.PropTypes.object,
   children: React.PropTypes.object,
};

export default ContactInvoice;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactInvoice/ContactInvoice.js
 **/